/**
 * Home Page JavaScript
 * Handles home page specific functionality
 */
class HomePage {
    constructor() {
        this.init();
    }

    init() {
        this.bindHeroSearchForm();
    }

    bindHeroSearchForm() {
        const searchForm = document.querySelector('.hero-search form');
        if (searchForm) {
            searchForm.addEventListener('submit', function (event) {
                event.preventDefault(); // Prevent the default form submission
                const locationField = this.querySelector('select[name="location"]');
                const locationValue = locationField.value;
                const encodedLocation = encodeURIComponent(locationValue); // Encode the location properly
                const actionUrl = `/affordable-local-storage?location=${encodedLocation}`;
                window.location.href = actionUrl; // Redirect to the properly encoded URL
            });
        }
    }
}

// Auto-initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    if (document.body.classList.contains('home-page') || document.querySelector('.hero-search')) {
        new HomePage();
    }
});
